import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { color } from '@kistech/kis-ui';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    controlCenterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      background: '#EFEFEF',
      color: '#2A2A2A',
      padding: '112px 32px 112px 32px',
      width: '100%',
      [theme.breakpoints.between('xs', 'md')]: {
        padding: '33px 32px 22px 32px'
      }
    },
    controlCenterImage: {
      width: '200px',
      [theme.breakpoints.down('xs')]: {
        width: '110px'
      }
    },
    controlImageBlock: {
      display: 'flex'
    },
    controlTextBlock: {
      alignItems: 'center',
      justifyContent: 'center',
      background: 'transparent',
      padding: '32px 0px 32px 0px',
      [theme.breakpoints.down('xs')]: {
        padding: '10px 0px 10px 0px'
      }
    },
    controlCenterHeading: {
      color: color.PRIMARY,
      textAlign: 'center',
      fontSize: '42px !important',
      margin: '0px !important',
      letterSpacing: 'normal !important',
      lineHeight: 'inherit !important',
      fontFamily: 'Poppins, sans-serif !important',
      [theme.breakpoints.down('xs')]: {
        fontSize: '23px !important'
      }
    },
    controlCenterDescription: {
      color: '#767676',
      textAlign: 'center',
      fontSize: '30px !important',
      margin: '0px !important',
      lineHeight: '1 !important',
      letterSpacing: 'normal !important',
      fontFamily: 'Poppins, sans-serif !important',
      [theme.breakpoints.down('xs')]: {
        fontSize: '18px !important'
      }
    }
  })
);
